var _style, _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMedal1 = function SvgMedal1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 26",
    style: {
      enableBackground: "new 0 0 24 26"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#A87A16;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#DAB700;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFD34D;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#F2BA49;}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st6{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#F2BA49;}\n")), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "medalla1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_-Plataforma-web-novedades",
    transform: "translate(-150.000000, -698.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(16.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "certificdador",
    transform: "translate(24.000000, 455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(93.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medalla1",
    transform: "translate(17.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "st0",
    points: "5,4 18,4 18,0 5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "st1",
    points: "18.8,0 10,16.2 15.2,19 24,2.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "st1",
    points: "5.2,0 0,2.8 8.8,19 14,16.2  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(1.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st2",
    d: "M18.4,7.7c0-4.2-3.6-7.6-8-7.6s-8,3.4-8,7.6s3.6,7.6,8,7.6S18.4,11.9,18.4,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st3",
    d: "M10.4,1.7c-3.5,0-6.3,2.7-6.3,6s2.8,6,6.3,6s6.3-2.7,6.3-6S13.8,1.7,10.4,1.7 M10.4,14.2 c-3.8,0-6.8-2.9-6.8-6.5s3.1-6.5,6.8-6.5s6.8,2.9,6.8,6.5S14.1,14.2,10.4,14.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "st3",
    points: "10.4,3.5 11.3,6.4 14.6,6.4 12,8.2 13,11.1 10.4,9.3 7.8,11.1 8.7,8.2 6.2,6.4  9.4,6.4  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(15.404335, 13.996023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.1,
    y: 0,
    width: 2.1,
    height: 2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.1,
    y: 0,
    width: 2.1,
    height: 2,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_1_",
    className: "st5",
    points: "0.1,0 2.1,0 2.1,2 0.1,2  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    className: "st6",
    points: "1.3,0.8 1.3,0 0.9,0 0.9,0.8 0.1,0.8 0.1,1.2 0.9,1.2 0.9,2 1.3,2 1.3,1.2  2.1,1.2 2.1,0.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    className: "st2",
    points: "1.6,2.5 1.6,1.9 1.3,1.9 1.3,2.5 0.6,2.5 0.6,2.8 1.3,2.8 1.3,3.4 1.6,3.4  1.6,2.8 2.3,2.8 2.3,2.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st3",
    d: "M1.1,6.9c0,0.2-0.2,0.4-0.5,0.4S0.1,7.1,0.1,6.9c0-0.2,0.2-0.4,0.5-0.4S1.1,6.6,1.1,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st2",
    d: "M2.7,12.2c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5 S2.7,11.9,2.7,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "st3",
    d: "M4,14c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7 C3.7,13.3,4,13.6,4,14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "st2",
    d: "M21.6,7.8c0,0.5-0.4,0.8-0.9,0.8c-0.5,0-0.9-0.4-0.9-0.8c0-0.5,0.4-0.8,0.9-0.8 C21.2,7,21.6,7.4,21.6,7.8"
  })))))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedal1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medal1.a69257aa.svg";
export { ForwardRef as ReactComponent };